import { Api } from '@/api/Api'
import { ActionTree } from 'vuex'
import State, { ICustomer, ICustomerContact, ICustomerSearchFilter } from './types'
import { RootState, ResponseArray } from '../types'
import SecurityState from '../security/types'
const api = new Api()

export const actions: ActionTree<State, RootState> = {
  setActiveCustomer(
    { state, commit },
    { customer }: { customer: ICustomer },
  ): any {
    if (state.activeCustomer.CustomerNumber !== customer.CustomerNumber) {
      commit('setActiveCustomer', { customer })
    }
  },
  async getCustomer({ commit, rootState }, customerNumber: string) {
    try {
      const securityState = (this.state as any).security as SecurityState
      commit('customerLoading')
      const url = `${rootState.apiPrefix ?? ''}/customer/${customerNumber}`
      return api
        .fetchV2({
          url,
          user: securityState.currentUser,
        })
        .then((response) => {
          if (response.Successful) {
            if (
              response.Data !== undefined &&
              response.Data !== null
            ) {
              const customer: ICustomer = response.Data
              commit('customerLoaded', { customer })
            } else {
              commit('customerLoadError', '')
            }
          } else {
            commit('customerLoadError', response.Message ?? response.Error)
          }
        })
        .catch(() => {
          commit(
            'customerLoadError',
            'Error processing request. Please try again later or contact support',
          )
        })
    } catch (error) {
      commit('customerLoadError', 'Please try again later or contact support')
    }
  },
  async getContacts({ commit }, customerNumber: string) {
    try {
      const securityState = (this.state as any).security as SecurityState
      commit('customerLoading')
      const url = `/customer/${customerNumber}/contacts`
      return api
        .fetchV2({
          url,
          user: securityState.currentUser,
        })
        .then((response) => {
          if (response.Successful) {
            if (
              response.List !== undefined &&
              response.List !== null
            ) {
              const customers: ResponseArray<ICustomerContact> = response
              commit('customerContactsLoaded', customers.List)
              return customers
            } else {
              commit('customersLoadError', 'Please try again later or contact support')
            }
          } else {
            commit('customersLoadError', response.Message ?? response.Error)
          }
        })
        .catch(() => {
          commit(
            'customerLoadError',
            'Error processing request. Please try again later or contact support',
          )
        })
    } catch (error) {
      commit('customerLoadError', 'Please try again later or contact support')
    }
  },
  fetchCustomerShipTos({ commit, rootState }, customerNumber: string): any {
    const securityState = (this.state as any).security as SecurityState
    const url = `${rootState.apiPrefix ?? ''}/Customer/shipTos?customerNumber=${customerNumber}`
    return api
      .fetchV2({
        url,
        user: securityState.currentUser,
      })
      .then((response) => {
        if (response.Successful) {
          if (
            response.List !== undefined &&
            response.List !== null
          ) {
            const customers: ResponseArray<ICustomer> = response
            commit('customerShipToLoaded', { customers })
            return customers
          } else {
            commit('customersLoadError', 'Please try again later or contact support')
          }
        } else {
          commit('customersLoadError', response.Message ?? response.Error)
        }
      })
      .catch(() => {
        commit('customersLoadError', 'Please try again later or contact support')
      })
  },
  async getAllCustomers({ commit, rootState, state }) {
    try {
      const securityState = (state as any).security as SecurityState
      commit('customersLoading')
      const url = `${rootState.apiPrefix ?? ''}/customer/all`
      api
        .fetchV2({
          url,
          user: securityState.currentUser,
        })
        .then((response) => {
          if (response.Successful) {
            if (
              response.List !== undefined &&
              response.List !== null
            ) {
              const customers: ResponseArray<ICustomer> = response
              commit('customersLoaded', { customers })
              return customers
            } else {
              commit('customersLoadError', '')
            }
          } else {
            commit('customersLoadError', response.Message ?? response.Error)
          }
        })
        .catch(() => {
          commit(
            'customersLoadError',
            'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('customerLoadError', 'Please try again later or contact support')
    }
  },
  async getCustomers(
    { commit, rootState },
    searchFilters: ICustomerSearchFilter,
  ) {
    try {
      commit('customersLoading')
      const {
        page,
        sortBy,
        sortDesc,
        customerNumber = '',
        customerName = '',
        filterByHasUsers = false,
        filterByHasPendingPermissions = false,
        pageSize = 30,
        city = '',
        state = '',
        postalCode = '',
      } = searchFilters
      const url = `${rootState.apiPrefix ?? ''}/customer?` +
        `PageSize=${pageSize}&Page=${page}&SortBy=${sortBy}&SortDirection=${(sortDesc ? 'desc' : 'asc')}` +
        `&CustomerNumber=${customerNumber}&customerName=${encodeURIComponent(customerName ?? '')}` +
        `&filterByHasUsers=${filterByHasUsers}&filterByHasPendingPermissions=${filterByHasPendingPermissions}` +
        `&City=${city}&City=${encodeURIComponent(city ?? '')}` +
        `&State=${state}&State=${encodeURIComponent(state ?? '')}` +
        `&PostalCode=${postalCode}&PostalCode=${encodeURIComponent(postalCode ?? '')}`

      api
        .fetchV2({
          url,
          user: (rootState as any).security.currentUser,
        })
        .then((response) => {
          if (response.Successful) {
            if (
              response.List !== undefined &&
              response.List !== null
            ) {
              const customers: ResponseArray<ICustomer> = response
              commit('customersLoaded', { customers })
              commit('customerFilterUpdated', searchFilters)
              return customers
            } else {
              commit('customersLoadError', '')
              commit('customerFilterError')
            }
          } else {
            commit('customersLoadError', response.Message ?? response.Error)
            commit('customerFilterError')
          }
        })
        .catch(() => {
          commit(
            'customerLoadError',
            'Error processing request. Please try again later or contact support',
          )
        })
      return false
    } catch (error) {
      commit('customerLoadError', 'Please try again later or contact support')
    }
  },
  async clearActiveCustomer({ commit }) {
    commit('customerClear')
  },
}
